import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

const Post = ({ element, index }) => {
  const post = element;
  const isPrimary = index % 2 === 0;
  const isDev = post.source === 'DEV';

  return (
    <div
      className="flex flex-col overflow-hidden border hover:-translate-y-1 hover:shadow-[0_8px_24px_rgba(0,255,65,0.1)] transition duration-200"
      style={{
        borderColor: isPrimary ? 'rgba(0,255,65,0.25)' : 'rgba(0,204,102,0.25)',
        backgroundColor: isPrimary ? 'rgba(0,255,65,0.03)' : 'rgba(0,204,102,0.03)',
      }}
    >
      {post.thumbnail && (
        <div className="h-32 overflow-hidden">
          <img
            src={post.thumbnail}
            alt={post.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover opacity-60 hover:opacity-90 transition-opacity"
          />
        </div>
      )}
      <div className="p-4 flex flex-col flex-1">
        {post.source && (
          <span
            className="self-start inline-block text-[10px] font-mono font-bold uppercase tracking-widest px-2 py-0.5 mb-2 border"
            style={{
              color: isDev ? '#00ff41' : '#00cc66',
              borderColor: isDev ? 'rgba(0,255,65,0.4)' : 'rgba(0,204,102,0.4)',
              backgroundColor: isDev ? 'rgba(0,255,65,0.06)' : 'rgba(0,204,102,0.06)',
            }}
          >
            {post.source}
          </span>
        )}
        <h4 className="font-bold font-mono text-white text-sm leading-snug mb-3 line-clamp-3">
          {post.title}
        </h4>
        <div className="mt-auto">
          <a
            className={`text-xs font-mono font-bold uppercase tracking-widest hover:opacity-80 transition-opacity flex items-center gap-2 ${
              isPrimary ? 'text-primary' : 'text-teal'
            }`}
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
            Leer_Artículo
          </a>
        </div>
      </div>
    </div>
  );
};

// Memo: al desplegar más posts con "Cargar_Más", las tarjetas ya montadas
// no se vuelven a renderizar.
export default React.memo(Post);
